import { ISize } from '@shared/definitions';
import { fromEvent } from 'rxjs';
import { map, take } from 'rxjs/operators';

export const getImgSize = (imageSrc: string) => {
  const mapLoadedImage = (event: Event): ISize => {
    const target = event.target as HTMLImageElement;
    return {
      width: target.width,
      height: target.height,
    };
  };
  const image = new Image();
  const $loadedImg = fromEvent(image, 'load').pipe(take(1), map(mapLoadedImage));
  image.src = imageSrc;
  return $loadedImg;
};
